import React, { Component } from 'react';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL } from '../Dashboard/api/Api';
class SignupHistory extends Component {

    constructor() {

        const lStorage = userloginDetails();
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        const isAdmin = lStorage?.user?.isAdmin;
        const AdminEmail = lStorage.user.username;
        const userPassword = lStorage.user.password;


        super();

        this.state = {
            user_id: userId,
            adminPassword: userPassword,
            AdminEmail: AdminEmail,
            userType: isAdmin,
            token: userToken,
            allUserList: null,
            serchData: '',
            userCurrentStatus: '',
            successMessage: false,
            errorMessage: '',
            bgColor: "alert alert-success alert-dismissible",
        }

    }

    componentDidMount() {
        this.onserch();
    }

    onserch() {
        const payload = {
            user_id: this.state.user_id,
            method: "signuphistory",
            type: this.state.userType,
            token: this.state.token,
        };

        fetch(`${HOST_URL}/admin_dashboard.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    this.setState({
                        allUserList: result,
                        userCurrentStatus: result.data[0].is_active
                    });
                } else {
                    this.setState({
                        successMessage: true,
                        successBg: "alert alert-danger alert-dismissible",
                        errorMessage: result.message,
                    });
                }
            })
            .catch((error) => {
                console.error("Error in onserch:", error);
            });
    }

    searchUser() {
        if (this.state.serchData === '') {
            this.onserch();
            this.setState({
                successMessage: true,
                errorMessage: "Enter User Name ",
                bgColor: "alert alert-danger alert-dismissible"
            });
        } else {
            const payload = {
                user_id: this.state.user_id,
                method: "signuphistory",
                type: "search",
                username: this.state.serchData,
                token: this.state.token,
            };

            fetch(`${HOST_URL}/admin_dashboard.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.success === true) {
                        this.setState({
                            successMessage: false,
                            allUserList: result
                        });
                    } else {
                        this.setState({
                            successMessage: true,
                            errorMessage: result.message,
                            bgColor: "alert alert-danger alert-dismissible"
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error in searchUser:", error);
                });
        }
    }



    render() {

        return (
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong> User Signup </strong> History </h3>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                    <div className="card flex-fill">

                                        <div className="card-header">

                                            <h5 className="card-title mb-0"> User Signup History </h5>
                                        </div>

                                        <div className="card-body">
                                            <div className="filter-option">

                                                <h6 className="card-subtitle text-muted">Filter </h6>

                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <div className="input-group-text"><FontAwesomeIcon icon={faSearch} /></div>
                                                            <input type="text" onChange={(event) => { this.setState({ serchData: event.target.value }) }} placeholder="Enter user id or name of users" className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-group mb-2 mr-sm-2">
                                                            <input type="button" onClick={() => this.searchUser()} value="Search" className="btn mt-1  btn-primary btn-sm btn-block ml-auto " />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                this.state.successMessage ?
                                                    <div className={this.state.bgColor} role="alert">
                                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                            <span aria-hidden="true">×</span>
                                                        </button>
                                                        <div className="">
                                                            {this.state.errorMessage}
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }

                                            {this.state.allUserList ?

                                                <div style={{ height: 400 + 'px' }} className="table-responsive">
                                                    <table className="table table-striped table-xs table-sm my-0">
                                                        <thead className="sticky-top">
                                                            <tr >
                                                                <th> Email ID / Mobile </th>
                                                                <th>Source</th>
                                                                <th>IP Address</th>
                                                                <th>Message</th>
                                                                <th>Input OTP / Generated OTP</th>
                                                                <th>Login Date / Time </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {
                                                                this.state.allUserList.data.map((item, i) =>

                                                                    <tr key={i}>
                                                                        <td>{item.email} <br />
                                                                            {item.mobile}
                                                                        </td>
                                                                        <td>{item.signup_via}</td>
                                                                        <td>{item.ip_address}</td>
                                                                        <td>{item.message}</td>
                                                                        <td>{item.otp}</td>
                                                                        <td>{item.created}</td>
                                                                    </tr>

                                                                )
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                                :
                                                <div className="text-center">
                                                    <div className="card-body">
                                                        <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                        <p>No Any Login History </p>

                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>

        );
    }
}
export default SignupHistory;